import { Preferences } from '@capacitor/preferences';

const ENROLLED_KEY = 'biometric_enrolled';
const DECLINED_KEY = 'biometric_prompt_declined';

export const biometricStorage = {
	async isEnrolled() {
		const { value } = await Preferences.get({ key: ENROLLED_KEY });
		return value === 'true';
	},

	async setEnrolled(enrolled) {
		if (enrolled) {
			await Preferences.set({ key: ENROLLED_KEY, value: 'true' });
		} else {
			await Preferences.remove({ key: ENROLLED_KEY });
		}
	},

	async isPromptDeclined() {
		const { value } = await Preferences.get({ key: DECLINED_KEY });
		return value === 'true';
	},

	async markPromptDeclined() {
		await Preferences.set({ key: DECLINED_KEY, value: 'true' });
	},

	async clearAll() {
		await Preferences.remove({ key: ENROLLED_KEY });
		await Preferences.remove({ key: DECLINED_KEY });
	},
};
